import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
export var useTheme = function () {
    var context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
/**
 * Get CSS classes based on current theme
 * @param baseClasses - Base classes that apply to all themes
 * @param darkClasses - Additional classes for dark theme
 * @returns Combined class string
 */
export var useThemeClasses = function (baseClasses, darkClasses) {
    var theme = useTheme().theme;
    if (theme === 'dark' && darkClasses) {
        return "".concat(baseClasses, " ").concat(darkClasses);
    }
    return baseClasses;
};
/**
 * Utility to generate consistent theme-aware classes
 */
export var themeClasses = {
    // Background variants
    bgPrimary: 'bg-background',
    bgSecondary: 'bg-muted/30',
    bgTertiary: 'bg-muted/50',
    // Text variants
    textPrimary: 'text-foreground',
    textSecondary: 'text-muted-foreground',
    // Border variants
    border: 'border-border',
    borderLight: 'border-muted',
    // Interactive states
    hover: 'hover:bg-muted/50',
    focus: 'focus:ring-2 focus:ring-ring focus:outline-none',
    // Cards
    card: 'bg-card border border-border',
    cardHeader: 'bg-muted/20 border-b border-border',
    // Buttons
    buttonPrimary: 'bg-primary text-primary-foreground hover:bg-primary/90',
    buttonSecondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    buttonOutline: 'border border-border bg-background hover:bg-muted',
    // Gradients - using CSS custom properties
    gradientPrimary: 'tab-gradient-primary',
    gradientSecondary: 'tab-gradient-secondary',
    gradientSuccess: 'tab-gradient-success',
    gradientWarning: 'tab-gradient-warning',
    gradientInfo: 'tab-gradient-info',
};
/**
 * Combines multiple theme classes
 */
export var cn = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();
};
